export default __webpack_public_path__ + "static/media/Group56.9d5cad3c.svg";